
const PUBLIC_PROD_API_SERVER = 'https://web-api.findinai.cn';
const PUBLIC_PREV_API_SERVER = 'https://web-api.pre.findinai.cn';

const pkg = process.env.NEXT_PUBLIC_PACKAGE;
const envApiHost = process.env.NEXT_PUBLIC_API_HOST;
const envApiServer = process.env.NEXT_API_SERVER;

// 客户端版本（使用 location.host）
export const getAPIHost = () => {
  if (typeof window === 'undefined') {
    // 服务端：优先使用 NEXT_API_SERVER
    return envApiServer || '/api/';
  }
  if (pkg === 'release') {
    const isPreviewEnv = window.location.host?.startsWith('preview') || false;
    if (isPreviewEnv) {
      return PUBLIC_PREV_API_SERVER;
    } else {
      return PUBLIC_PROD_API_SERVER;
    }
  } else {
    // 非 release 环境：优先使用环境变量配置
    if (envApiHost) {
      return `https://${envApiHost}`;
    }
    if (envApiServer) {
      return envApiServer;
    }
    // 兜底：使用 stage 环境
    return 'https://findin-api.t.xiehuaai.com';
  }
}

export const api = (url: string, direct?: boolean) => {
  url = url.replace(/^\//, '');
  if (direct) {
    return `${getAPIHost()}/${url}`;
  }
  return `/api/${url}`;
}

export const host = (url: string) => {
  return api(url, true);
}

